import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Mail, Phone, Smartphone, Users } from "lucide-react";
import React from "react";

interface StatData {
  title: string;
  count: number;
  icon: React.ReactNode;
}

interface DashboardProps {
  statsData?: StatData[];
}

const Dashboard: React.FC<DashboardProps> = ({ statsData }) => {
  const displayData = statsData;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {displayData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default Dashboard;
